import { combineReducers } from "redux";

import authReducers from "./authReducers";
import orderReducers from "./orderReducers";
import productReducers from "./productsReducers";
import quotesReducers from "./quotesReducers";
import allReducers from "./allReducers";
import productGroupReducers from "./productGroupReducers";

const appReducer = combineReducers({
    auth: authReducers,
    orders: orderReducers,
    products: productReducers,
    quotes: quotesReducers,
    redux: allReducers,
    productGroups: productGroupReducers
});

const rootReducer = (state, action) => {
    if (action.type === "LOGOUT") {
        return appReducer(undefined, action);
    }
    return appReducer(state, action);
};
export default rootReducer;
